import { ClassNameProps } from "@/types";

enum SkipDirection {
  Forward = "forward",
  Backward = "backward",
}

interface SkipButtonProps extends ClassNameProps {
  /* Direction to skip: 'forward' or 'backward' */
  direction: SkipDirection;

  /* Number of seconds to skip */
  seconds: number;

  /* Callback function when button is clicked */
  onClick: () => void;

  /* Optional aria label override */
  ariaLabel?: string;
}

export { SkipDirection };
export type { SkipButtonProps };
